import React, { useEffect } from "react";
import Auth from "./views/Auth/Auth";
import Dashboard from "./views/Dashboard/Dashboard";
import Admin from "./views/Admin/Admin";
import WallofLegendContentEngagementTab from "./views/WallofLegend-ContentEngagementTab/WallofLegendContentEngagementTab";
import { Switch, Route, useHistory } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import PrivateRoute from "./PrivateRoute";
import theme from "./theme";
import Events from "./views/Events/Events";
import DriverDetailsView from "./views/DriverDetails/DriverDetails";
import AnalyticsView from "../src/views/Analytics/Analytics";
import { hotjar } from "react-hotjar";
import ReactGA from "react-ga";
import ContentDetailsView from "./views/ContentDetails/ContentDetails";
import ContentLayout from "./components/ContentLayout/ContentLayout";
import SearchResult from "./views/SearchResult/SearchResult";
import User from "./views/Admin/User/User";
import SmartAppDialog from "./components/Dialogs/SmartApp/SmartApp";
import ReportedEventDetails from './views/ReportedEventDetails/ReportedEventDetails';
import ReportedEvents from "./views/ReportedEvents/ReportedEvents";
// import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
    getSmartAppDialogState,
    getUserData,
    getUserRBAC,
} from "./services/LocalStorageService";
import { detectMobile } from "./config/app-global-method";
import qs from "querystring";
import { EntityAccess, RBAC_CODE } from "./config/app-globals.enum";
import NoAccess from "./components/NoAccess/NoAccess";
import TableGenerates from './components/TableGenerate/TableGenerate';
import AdminReportedEventDetails from "./views/ReportedEventDetails/AdminReportedEventDetails";
import DriverLocator from "./views/DriverLocator/DriverLocator";
import Group from "./views/Admin/Group/Group";
import MileageClaims from "./views/Admin/MileageClaims/MileageClaims";
import MileageClaimDetails from "./views/Admin/MileageClaims/MileageClaimDetails";

function App(props) {
    const [userData] = React.useState(getUserData);
    const [getRBAC_ContentView] = React.useState(
        getUserRBAC(RBAC_CODE.CONTENT_VIEW, props)
    );
    const history = useHistory();
    const hjid = 1979030;
    const hjsv = 6;
    hotjar.initialize(hjid, hjsv);

    useEffect(() => {
        const gaCode = `${process.env.REACT_APP_GOOGLE_TAG_ID}`;
        ReactGA.initialize(gaCode);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    useEffect(() => {
        if (history.location && history.location.search) {
            const queryParams = qs.parse(history.location.search);
            setIsMobileToken(queryParams["?mobileToken"] ? true : false);
        }
    }, [history.location]);

    const [smartAppDialogState] = React.useState(getSmartAppDialogState);
    const [isMobileToken, setIsMobileToken] = React.useState(false);
    // const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [isMobileDevice] = React.useState(detectMobile);
    // const isIpad = useMediaQuery(theme.breakpoints.up("md"));
    // const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Switch>
                <PrivateRoute path="/(|dashboard)" render={Dashboard} exact />
                <PrivateRoute path="/(|dashboard/)impersonation/:impersonationid" render={Dashboard} exact />
                <PrivateRoute
                    path="/(engagement|walloflegends)"
                    render={WallofLegendContentEngagementTab}
                    exact
                />
                <PrivateRoute
                    path="/(locator)"
                    render={DriverLocator}
                    exact
                />
                <PrivateRoute
                    path="/impersonation/:impersonationid/(engagement|walloflegends)"
                    render={WallofLegendContentEngagementTab}
                    exact
                />
                <PrivateRoute
                    path="/(analytics|exports)"
                    render={AnalyticsView}
                    exact
                />

                <PrivateRoute
                    path="/customtable/:tcId/:tcAction/:tcViewId?"
                    render={TableGenerates}
                    exact
                />
                <PrivateRoute
                    path="/impersonation/:impersonationid/(analytics|exports)"
                    render={AnalyticsView}
                    exact
                />

                <PrivateRoute path="/events" render={Events} exact />
                {/* <PrivateRoute path="/impersonation/:impersonationid/events" render={Events} exact /> */}
                <PrivateRoute
                    path="/userdetails/:id"
                    render={DriverDetailsView}
                    exact
                />

                <PrivateRoute
                    path="/impersonation/:impersonationid/userdetails/:id"
                    render={DriverDetailsView}
                    exact
                />

                <PrivateRoute path="/admin" render={Admin} exact />
                {/* <PrivateRoute path="/admin/users" render={AddUser} exact /> */}
                <PrivateRoute path="/admin/users" render={User} exact />
                <PrivateRoute path="/admin/users/:userId" render={User} exact />
                {/* <PrivateRoute path="/admin/users/edit/:userId" render={EditUser} exact /> */}
                <PrivateRoute path="/admin/users/edit/:userId" render={User} exact />
                <PrivateRoute path="/admin/groups/add" render={Group} exact />
                {/* <PrivateRoute path="/admin/groups/:groupId" render={Group} exact /> */}
                <PrivateRoute path="/admin/groups/view/:groupId" render={Group} exact />
                <PrivateRoute path="/admin/groups/edit/:groupId" render={Group} exact />
                <PrivateRoute path="/admin/search" render={SearchResult} exact />
                <PrivateRoute path="/eventdetails/:userId/:eventId/:reportStatus" render={ReportedEventDetails} exact />
                <PrivateRoute path="/admin/eventdetails/:userId/:eventId/:reportStatus" render={AdminReportedEventDetails} exact />
                <PrivateRoute path="/admin/reported-events" render={ReportedEvents} exact />
                <PrivateRoute path="/admin/mileage-claims" render={MileageClaims} exact />
                <PrivateRoute path="/mileage-claim-details/:userId/:mileageClaimId" render={MileageClaimDetails} exact />
                <Route
                    exact
                    path="/login"
                    render={(props) => <Auth {...props}> </Auth>}
                />
                <Route
                    exact
                    path="/logout"
                    render={(props) => <Auth {...props}> </Auth>}
                />
                <Route
                    exact
                    path="/forgotpassword"
                    render={(props) => <Auth {...props}> </Auth>}
                />
                <Route
                    exact
                    path="/resetpassword"
                    render={(props) => <Auth {...props}> </Auth>}
                />
                {userData && getRBAC_ContentView && getRBAC_ContentView.isAccessible === EntityAccess.ALLOWED ? (
                    <Route
                        path="/impersonation/:impersonationid/contents/:id"
                        render={(props) => (
                            <ContentLayout {...props}>
                                <ContentDetailsView {...props} />
                            </ContentLayout>
                        )}
                        exact
                    />
                ) : (
                    <Route
                        exact
                        path="/impersonation/:impersonationid/contents/:id"
                        component={(props) => (
                            <ContentLayout {...props}>
                                <NoAccess />
                            </ContentLayout>
                        )}
                    />
                )}

                {userData && getRBAC_ContentView ? (
                    <>
                        {getRBAC_ContentView.isAccessible === EntityAccess.ALLOWED ? (
                            <Route
                                path="/contents/:id"
                                render={(props) => (
                                    <ContentLayout {...props}>
                                        <ContentDetailsView {...props} />
                                    </ContentLayout>
                                )}
                                exact
                            />
                        ) : (
                            <Route
                                exact
                                path="/contents/:id"
                                component={(props) => (
                                    <ContentLayout {...props}>
                                        <NoAccess />
                                    </ContentLayout>
                                )}
                            />
                        )}
                    </>
                ) : (
                    <Route
                        path="/contents/:id"
                        render={(props) => (
                            <ContentLayout {...props}>
                                <ContentDetailsView {...props} />
                            </ContentLayout>
                        )}
                        exact
                    />
                )}

                {/* <Route
            path="/contents/:id"
            render={(props) => (
              <ContentLayout {...props}>
                <ContentDetailsView {...props} />
              </ContentLayout>
            )}
            exact
          /> */}
                <Route
                    path="/driverportal/content/loadcampaigncontent/:contentId/:userOldId"
                    render={(props) => (
                        <ContentLayout {...props}>
                            <ContentDetailsView {...props} />
                        </ContentLayout>
                    )}
                    exact
                />
                <Route
                    path="/impersonation/:impersonationid/driverportal/content/loadcampaigncontent/:contentId/:userOldId"
                    render={(props) => (
                        <ContentLayout {...props}>
                            <ContentDetailsView {...props} />
                        </ContentLayout>
                    )}
                    exact
                />
                <Route
                    path="//driverportal/content/loadcampaigncontent/:contentId/:userOldId"
                    render={(props) => (
                        <ContentLayout {...props}>
                            <ContentDetailsView {...props} />
                        </ContentLayout>
                    )}
                    exact
                />
                <Route path="*" render={(props) => <Auth {...props}> </Auth>} />
            </Switch>
            {
                isMobileDevice &&
                    (!smartAppDialogState ||
                        (smartAppDialogState && smartAppDialogState.isOpen)) &&
                    isMobileToken === false
                    ? (<SmartAppDialog />)
                    : null
            }
        </ThemeProvider>
    );
}

export default App;
